import { AfterViewInit, Component, ElementRef, Input, signal, ViewChild, WritableSignal } from '@angular/core';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-modal',
  imports: [],
  standalone: true,
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent implements AfterViewInit {

  @Input('backdropStatic') backdropStatic?: boolean = false;

  @ViewChild('modal', { static: false }) modal!: ElementRef;

  public id: string = 'modal-id';

  private _modalInstance!: Modal;
  private _onClose!: Function | undefined;

  protected size: string = '';
  protected isOpened: WritableSignal<boolean> = signal(false);

  ngAfterViewInit() {
    //Creo l'istanza per gestire i metodi delle modali di bootstrap
    this._modalInstance = new Modal(this.modal.nativeElement);
    //Aggiungo il listener per la chiusura
    this.addListener();
  }

  /**
   * Metodo che costruisce e apre la modale.
   *
   * @param onCloseCallback callback da invocare in fase di chiusura
   * @param size dimensione della modale (default è md)
   */
  public buildModal(onCloseCallback?: Function, size?: 'lg' | 'md' | 'sm' | 'modal-fullscreen', id?: string) {
    if (id) {
      this.id = id;
    }
    if (onCloseCallback) {
      this._onClose = onCloseCallback;
    }
    this.size = size || 'md';
    this.openModal()
  }

  /**
   * Apre la modale usando l'istanza della modale di bootstrap e aggiornando un signal.
   */
  private openModal() {
    this._modalInstance?.show();
    this.isOpened.set(true);
  }

  /**
   * Chiude la modale usando l'istanza della modale di bootstrap, aggiornando un signal, rimuovendo il listener sul dismiss
   * e invocando la funzione di chiusura.
   */
  private closeModal() {
    this.isOpened.set(false);
    this.removeListener();
    this._modalInstance?.hide();
    if (this._onClose) {
      this._onClose();
    }
  }

  /**
   * Metodo che dismette la modale senza invocare la funzione di chiusura.
   */
  public dismiss() {
    this.isOpened.set(false);
    this._modalInstance?.hide();
    this.removeListener();
  }

  private addListener() {
    this.modal.nativeElement.addEventListener('hidden.bs.modal', () => this.closeModal())
  }

  private removeListener() {
    this.modal.nativeElement.removeEventListener('hidden.bs.modal', () => this.closeModal());
  }

}
